import { ModeView } from '../../../shared/ontology/model/mode-view.enum';
import { Component, Input } from '@angular/core';
import { VariableDetails } from '../../../shared/ontology/model/variable-details';
import { Formula } from '../../../shared/ontology/model/formula';
import { FormulaService } from '../../../shared/ontology/service/formula.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { AlertService } from '../../../shared/alert/alert.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormulaDialogComponent } from './dialog/formula-dialog.component';
import { ModalConfirmComponent } from '../../../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormulaVariable } from '../../../shared/ontology/model/formula-variable';
import { OntologyContext } from '../../ontology.context';

@Component({
    selector: 'jhi-formula',
    templateUrl: './formula.component.html',
    styles: [
        `.underlined-heading {
            border-bottom: solid 1px #eee;
            padding-bottom: 0.5rem;
        }`
    ]
})
export class FormulaComponent {
    protected readonly ModeView = ModeView;

    @Input() modeView: ModeView;
    @Input() variable: VariableDetails;
    @Input() isFormulaExpanded = false;
    isLoading = false;

    constructor(private activeModal: NgbActiveModal,
                private modalService: NgbModal,
                private router: Router,
                private alertService: AlertService,
                private formulaService: FormulaService,
                private ontologyContext: OntologyContext,
                private translateService: TranslateService) {
    }

    toggle(): void {
        this.isFormulaExpanded = !this.isFormulaExpanded;
    }

    protected delete(formula: Formula) {
        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
        const message = !this.variable.metadata.deletable && this.variable?.formula?.formulaId ? 'ontology-manager.variable.formula.in.used.confirm.deletion.message' : 'ontology-manager.variable.formula.confirm.deletion.message';
        confirmModalRef.componentInstance.message = this.translateService.instant(message);
        confirmModalRef.result.then(() => {
            this.isLoading = true;
            this.formulaService.delete(formula.formulaId).pipe(
                finalize(() => {
                    this.isLoading = false;
                    this.variable.formula = null;
                })
            ).subscribe(() => {
                this.alertService.success('ontology-manager.variable.formula.deleted.success');
            });
        });
    }

    protected edit() {
        this.activeModal.dismiss('cancel');
        const formulaModalRef = this.modalService.open(FormulaDialogComponent as Component, {
            size: 'lg',
            backdrop: 'static'
        });
        formulaModalRef.componentInstance.variable = this.variable;
    }

    protected add() {
        this.activeModal.dismiss('cancel');
        const formulaModalRef = this.modalService.open(FormulaDialogComponent as Component, {
            size: 'lg',
            backdrop: 'static'
        });
        formulaModalRef.componentInstance.variable = this.variable;
    }

    protected openlink(input: FormulaVariable) {
        this.activeModal.dismiss('cancel');
        if (!this.ontologyContext?.previousVariableRoute) {
            this.ontologyContext.previousVariableRoute = [];
        }
        this.ontologyContext.previousVariableRoute.push(parseInt(this.variable.id, 10));
        setTimeout(() => {
            this.router.navigate(
                ['/', { outlets: { popup: ['variables', input.id, 'view'] } }],
                { queryParamsHandling: 'merge' }
            );
        });
    }
}
